// managerApi.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const managerApi = createApi({
  reducerPath: "managerApi",
  baseQuery: customFetchBase({ url: "manager" }),
  endpoints: (builder) => ({
    // Login manager
    loginManager: builder.mutation({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

// Export hooks
export const { useLoginManagerMutation } = managerApi;
